export default "__VITE_ASSET__610981d7__"